import { render, staticRenderFns } from "./DomainDnssecPublicKeyModal.vue?vue&type=template&id=59a233d2&"
import script from "./DomainDnssecPublicKeyModal.vue?vue&type=script&lang=js&"
export * from "./DomainDnssecPublicKeyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports